import axios from '../utils/axiosConfig';

const authAPI = {
  register: async (userData) => {
    const response = await axios.post('/auth/register', userData);
    return response.data;
  },

  login: async (credentials) => {
    const response = await axios.post('/auth/login', credentials);
    return response.data;
  },

  verifyPhone: async (data) => {
    const response = await axios.post('/auth/verify-phone', data);
    return response.data;
  },

  resendVerification: async (phone) => {
    const response = await axios.post('/auth/resend-verification', { phone });
    return response.data;
  },

  forgotPassword: async (email) => {
    const response = await axios.post('/auth/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (token, newPassword) => {
    const response = await axios.post('/auth/reset-password', { 
      token, 
      newPassword 
    });
    return response.data;
  },

  verifyResetOtp: async (email, otp) => {
    const response = await axios.post('/auth/verify-reset-otp', { email, otp });
    return response.data;
  },

  resendResetOtp: async (email) => {
    const response = await axios.post('/auth/resend-reset-otp', { email });
    return response.data;
  },

  getProfile: async () => {
    const response = await axios.get('/auth/profile');
    return response.data;
  },

  updateProfile: async (profileData) => {
    const response = await axios.put('/auth/profile', profileData);
    return response.data;
  },

  // New: Upload avatar
  uploadAvatar: async (file) => {
    const formData = new FormData();
    formData.append('avatar', file);
    
    const response = await axios.post('/auth/profile/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // New: Delete avatar
  deleteAvatar: async () => {
    const response = await axios.delete('/auth/profile/avatar');
    return response.data;
  },

  changePassword: async (data) => {
    const response = await axios.post('/auth/change-password', data);
    return response.data;
  },

  logout: async () => {
    const response = await axios.post('/auth/logout');
    return response.data;
  },

  refreshToken: async (refreshToken) => {
    const response = await axios.post('/auth/refresh-token', { refreshToken });
    return response.data;
  },
};

export default authAPI;